<template>
    <div class="wrap">
        <div class="content">
            <!-- 筛选 -->
            <div class="filter">
                <div class="filter_row">
                    <!-- 日历区间选择组件，样式美丽但性能不好，供选择参考 -->
                    <!-- <div class="filterItem">
                        <span @click="dateShow = true">{{ dataRange }}</span>
                        <van-icon
                            v-if="!searchParam.startAt"
                            class-prefix="vant-ali-sanjiaodown"
                            class="downArrow"
                            @click="dateShow = true"
                        />
                        <van-icon
                            v-else
                            class-prefix="vant-ali-qingkong-"
                            class="clearDate"
                            @click="clearDate"
                        />
                    </div> -->

                    <!-- 时间选择组件，替换上面日历组件 -->
                    <div class="filterItem">
                        <span @click="showDateStart=true">{{ startTime }}</span>
                        <span class="heng">-</span>
                        <span @click="showDateEnd=true">{{ endTime }}</span>
                    </div>


                    <div class="filterItem" @click="typePopup = true">
                        <span>{{ fileTypeName }}</span>
                        <van-icon
                            class-prefix="vant-ali-sanjiaodown"
                            class="downArrow"
                        />
                    </div>

                    <div class="filterItem" @click="childPopup = true" v-if="$store.state.userInfo.userInfo.userType=='ADMIN_ACCOUNT'&&childList.length>1">
                        <span>{{ childAccountName }}</span>
                        <van-icon
                            class-prefix="vant-ali-sanjiaodown"
                            class="downArrow"
                        />
                    </div>
            
                </div>
            </div>
            <!-- 列表 -->
            <div class="list" ref="fileList">
                <div class="list_title">
                    <b>文件列表</b>
                    <span @click="$router.push({path:'/time/ApplyTime'})">
                        <van-icon
                            class-prefix="vant-ali-tianjiawenjianjia"
                            class="addFile"
                        />
                        添加文件
                    </span>
                </div>
                <div class="noData" v-if="tableData.length==0">
                    <img src="@/assets/img/empty.png" alt="">
                    <p>暂无数据</p>
                </div>
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-else>
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        :immediate-check="false"
                        :offset="50"
                        @load="onLoad"
                    >
                        <ul class="list_wrap">
                            <li v-for="item in tableData" :key="item.serialNo">
                                <div class="dl" @click="lookDetail(item)">
                                    <div class="dt">
                                        <dl>
                                            <dt>申请人：</dt>
                                            <dd>{{item.applyName}}</dd>
                                        </dl>
                                        <dl>
                                            <dt>申请账号：</dt>
                                            <dd>{{item.applyAccount}}</dd>
                                        </dl>
                                        <dl>
                                            <dt>文件名称：</dt>
                                            <dd>{{item.opusName}}</dd>
                                        </dl>
                                        <dl>
                                            <dt>文件类型：</dt>
                                            <dd>{{item.fileTypeName}}</dd>
                                        </dl>
                                        <dl>
                                            <dt>申请时间：</dt>
                                            <dd>{{ item.operatedAt?item.operatedAt:'' | formatDate}} (UTC+8)</dd>
                                        </dl>
                                    </div>
                                    <!-- hasFileDefault -->
                                    <div class="dd">
                                        <img src="@/assets/img/noFileDefault.png" alt="" v-if="item.sourceFileUploadType == 0">
                                        <img :src="item.sourceFileStorePathUrl" alt="" v-else-if="['png', 'gif', 'jpg', 'jpeg'].includes(item.extensiveType)">
                                        <img src="@/assets/img/hasFileDefault.png" alt="" v-else>
                                    </div>
                                </div>
                                <div class="btn" @click="lookDetail(item)">
                                    <span>查看详情</span>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </div>
        </div>
        <!-- 筛选弹框部分 -->
        <div>
            <!-- 日历组件 -->
            <!-- <van-calendar
                v-model="dateShow"
                @confirm="onConfirm"
                :minDate="new Date('2008-01-01')"
                :maxDate="new Date()"
                :default-date="[new Date(new Date().getTime() - 24*60*60*1000),new Date()]"
                type="range"
                color="#1989fa"
            /> -->

            <!-- 时间选择组件，替换上边的日历组件 -->
            <van-popup v-model="showDateStart" position="bottom" round>
                <van-datetime-picker
                    v-model="currentDateStart"
                    :max-date="maxDate"
                    :min-date="minDate"
                    cancel-button-text="重置"
                    title="开始日期"
                    type="date"
                    @cancel="currentDateStartCancel"
                    @confirm="confirmDateStart"
                />
            </van-popup>
            <van-popup v-model="showDateEnd" position="bottom" round>
                <van-datetime-picker
                    v-model="currentDateEnd"
                    :max-date="maxDate"
                    :min-date="minDate"
                    cancel-button-text="重置"
                    title="结束日期"
                    type="date"
                    @cancel="currentDateEndCancel"
                    @confirm="confirmDateEnd"
                />
            </van-popup>
            <!-- type -->
            <van-popup
                v-model="typePopup"
                :style="{ height: '70%' }"
                class="datePopup sourcePopup"
                closeable
                position="bottom"
                round
            >
                <div class="title">文件类型</div>
                <div class="choose">
                    <van-radio-group v-model="searchParam.fileType" class="chooseList">
                        <van-cell-group class="chooseScroll">
                            <van-cell clickable title="全部" @click="toggleTypeAll">
                                <template #right-icon>
                                    <van-radio icon-size="20px" name="" />
                                </template>
                            </van-cell>
                            <van-cell
                                v-for="item in fileType"
                                :key="item.selectValue"
                                :title="item.title"
                                clickable
                            >
                                <template #right-icon>
                                    <van-radio
                                        ref="checkboxes"
                                        :name="item.selectValue"
                                        icon-size="20px"
                                    />
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                    <van-row class="sourceFlex" justify="center" type="flex">
                        <van-col span="24">
                            <span class="sub" @click="saveFileType">确认</span>
                        </van-col>
                    </van-row>
                </div>
            </van-popup>
            <!-- child -->
            <van-popup
                v-model="childPopup"
                :style="{ height: '70%' }"
                class="datePopup sourcePopup"
                closeable
                position="bottom"
                round
            >
                <div class="title">申请账号</div>
                <div class="choose">
                    <van-radio-group v-model="searchParam.applyAccountIds" class="chooseList">
                        <van-cell-group class="chooseScroll">
                            <van-cell clickable title="全部" @click="toggleChildAll">
                                <template #right-icon>
                                    <van-radio icon-size="20px" name="" />
                                </template>
                            </van-cell>
                            <van-cell
                                v-for="v in childList"
                                :key="v.accountId"
                                :title="v.accountName.toString()"
                                clickable
                            >
                                <template #right-icon>
                                    <van-radio
                                        ref="checkboxes"
                                        :name="v.accountId"
                                        icon-size="20px"
                                    />
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                    <van-row class="sourceFlex" justify="center" type="flex">
                        <van-col span="24">
                            <span class="sub" @click="saveFileChild">确认</span>
                        </van-col>
                    </van-row>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
import { opusList,findChild } from '@/api/service'
import { formatDate, filterParams} from '@/utils/filter'
export default {
    data() {
        return {
            // dateShow: false,
            // dataRange: "选择日期区间",
            showDateStart:false,
            showDateEnd:false,
            minDate: new Date(2008, 0, 1),
            maxDate: new Date(),
            currentDateStart:new Date(),
            currentDateEnd:new Date(),
            startTime:'开始日期',
            endTime:'结束日期',
            fileTypeName: "文件类型",
            fileType: [
                {
                    title: '商业秘密',
                    value: 109,
                    selectValue: 'BUSINESS_SECURITY',
                },
                {
                    title: '工业项目',
                    value: 119,
                    selectValue: 'INDUSTRIAL_PROJECT',
                },
                {
                    title: '软件项目',
                    value: 108,
                    selectValue: 'SOFTWARE',
                },
                {
                    title: '硬件项目',
                    value: 120,
                    selectValue: 'HARD_PROJECT',
                },
                {
                    title: '科研成果',
                    value: 121,
                    selectValue: 'SCIENTIFIC_PAYOFFS',
                },
                {
                    title: '数据资产',
                    value: 122,
                    selectValue: 'DATA_ASSETS',
                },
                {
                    title: '商标设计',
                    value: 123,
                    selectValue: 'TRADEMARK_DESIGN',
                },
                {
                    title: '专利文档',
                    value: 124,
                    selectValue: 'PATENT_DOCUMENT',
                },
                {
                    title: '文字作品',
                    value: 101,
                    selectValue: 'WORD',
                },
                {
                    title: '视听作品',
                    value: 112,
                    selectValue: 'VIDEO',
                },
                {
                    title: '摄影作品',
                    value: 110,
                    selectValue: 'PHOTOGRAPHY',
                },
                {
                    title: '美术作品',
                    value: 104,
                    selectValue: 'FINE_ARTS',
                },
                {
                    title: '音乐作品',
                    value: 102,
                    selectValue: 'MUSIC',
                },
                {
                    title: '设计作品',
                    value: 105,
                    selectValue: 'DESIGN',
                },
                {
                    title: '讲义课件',
                    value: 125,
                    selectValue: 'HANDOUTS_COURSEWARE',
                },
                {
                    title: '其它',
                    value: 999,
                    selectValue: 'OTHER',
                },
            ],
            typePopup: false,
            childPopup:false,
            childAccountName:'申请账号',
            childList:[],
            searchParam: {
                page: 1,
                size: 10,
                fileType: "",
                startAt: "",
                endAt: "",
                applyAccountIds: "",
            },
            total:10,
            tableData:[],
            loading: false,
            refreshing: false,
            finished: false,
        };
    },

    components: {},
    
    filters: {
        formatDate: formatDate,
    },

    computed: {},

    created() {
        this.getOpusList(filterParams(this.searchParam))
        this.getChildList()
    },

    mounted() {
        this.$refs.fileList.addEventListener('scroll', () =>{
            // 实时 滑动的距离 会保存在 vuex中，也可以保存在 session storage中
            this.$setlocalStorage("scrollY", this.$refs.fileList.scrollTop);
            // this.$store.commit('setState', {searchTop: this.$refs.searchList.scrollTop})
        })
    },
    beforeRouteEnter (to, from, next) {
        next(async vm =>{
            let params=JSON.parse(JSON.stringify(vm.searchParam))
            //设置之前翻到的页码
            vm.searchParam.page=vm.$getlocalStorage("currentPage")?vm.$getlocalStorage("currentPage"):1;
            //更新数据，还要还原之前的数据条数以便滚到原来的位置
            params.page=1;
            params.size=vm.$getlocalStorage("currentPage")?vm.$getlocalStorage("currentPage")*10:10;
            await vm.getOpusList(filterParams(params));
            // 详情页进入列表页滚动条滚到之前位置
            if(from.name =='FileDetail'){
                setTimeout(()=>{
                    vm.$refs.fileList.scrollTop = vm.$getlocalStorage('scrollY')
                },0)
            }else{
                // 非详情页进入搜索页 设置滚动条为初始值 0
                vm.$setlocalStorage("scrollY", 0);
            }
        })
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== 'FileDetail') {
            this.$vnode.parent.componentInstance.cache = {}
            this.$vnode.parent.componentInstance.keys = []
        }
        next();
    },

    methods: {
        async getOpusList(data,add=false) {
            let res = await opusList(data)
            this.loading = false
            if(add){
                if(res.data.length==0){
                    this.finished = true
                }else{
                    this.tableData = [...this.tableData,...res.data];
                }
            }else{
                this.$refs.fileList.scrollTop=0;
                this.refreshing = false
                this.tableData = res.data;
            }
            this.total = res.total;
        },
        async getChildList() {
            let res = await findChild()
            if(res){
                this.childList=res;
            }
            console.log(res)
        },
        // 日历组件方法
        // formatDate(date) {
        //     return `${date.getFullYear()}/${
        //         date.getMonth() + 1
        //     }/${date.getDate()}`;
        // },
        // onConfirm(date) {
        //     const [start, end] = date;
        //     this.dateShow = false;
        //     if (start && end) {
        //         this.searchParam.startAt = new Date(start).getTime();
        //         this.searchParam.endAt = new Date(end).getTime()+24*60*60*1000;
        //         this.dataRange = `${this.formatDate(start)} - ${this.formatDate(
        //             end
        //         )}`;
        //     } else {
        //         this.dataRange = `选择日期区间`;
        //     }
        //     this.searchParam.page = 1;
        //     this.finished = false;
        //     this.getOpusList(filterParams(this.searchParam));
        // },
        // clearDate() {
        //     this.searchParam.startAt = "";
        //     this.searchParam.endAt = "";
        //     this.dataRange = `选择日期区间`;
        //     this.searchParam.page = 1;
        //     this.finished = false;
        //     this.getOpusList(filterParams(this.searchParam));
        //     this.$refs.fileList.scrollTop=0;
        // },
        
        // 时间组件方法
        confirmDateStart(val) {
            // console.log(new Date(val).getTime())
            this.startTime = `${val.getFullYear()}/${val.getMonth() + 1}/${val.getDate()}`
            this.showDateStart = false;
            this.searchParam.startAt = new Date(val).getTime();
            this.searchParam.page = 1;
            this.getOpusList(filterParams(this.searchParam));
        },
        confirmDateEnd(val) {
            this.endTime = `${val.getFullYear()}/${val.getMonth() + 1}/${val.getDate()}`
            this.showDateEnd = false;
            this.searchParam.endAt = new Date(val).getTime()+24*60*59*1000;
            this.searchParam.page = 1;
            this.getOpusList(filterParams(this.searchParam));
        },
        currentDateStartCancel() {
            this.startTime = '开始日期'
            this.searchParam.startAt = ''
            this.showDateStart = false;
            this.searchParam.page = 1;
            this.getOpusList(filterParams(this.searchParam));
        },
        currentDateEndCancel() {
            this.endTime = '结束日期'
            this.searchParam.endAt = ''
            this.showDateEnd = false;
            this.searchParam.page = 1;
            this.getOpusList(filterParams(this.searchParam));
        },
        toggleTypeAll() {
            this.fileTypeName = '文件类型';
            this.searchParam.fileType = '';
            this.$refs.fileList.scrollTop=0;
        },
        saveFileType(){
            this.fileTypeName=this.fileTypeCurrent(this.searchParam.fileType);
            // this.fileTypeName=this.fileType.find((item)=>{
            //     item.value=this.searchParam.fileType;
            // }).title;
            this.typePopup=false;
            this.searchParam.page = 1;
            this.finished = false;
            this.getOpusList(filterParams(this.searchParam));
            this.$refs.fileList.scrollTop=0;
        },
        fileTypeCurrent(val) {
            switch (val) {
                case '':
                    return "文件类型";
                    break;
                case 'WORD':
                    return '文字作品'
                    break
                case 'MUSIC':
                    return '音乐作品'
                    break
                case 'PHONOTAPE_AND_VIDEOTAPE':
                    return '音像'
                    break
                case 'FINE_ARTS':
                    return '美术作品'
                    break
                case 'DESIGN':
                    return '设计作品'
                    break
                case 'SCULPTURE':
                    return '雕塑'
                    break
                case 'ENGINEERING_DRAWING':
                    return '工程图纸'
                    break
                case 'SOFTWARE':
                    return '软件项目'
                    break
                case 'BUSINESS_SECURITY':
                    return '商业秘密'
                    break
                case 'PHOTOGRAPHY':
                    return '摄影作品'
                    break
                case 'PRODUCT_DESIGN_DRAWING':
                    return '产品设计图'
                    break
                case 'VIDEO':
                    return '视听作品'
                    break
                case 'SAMPLE_REELS':
                    return '汇编作品'
                    break
                case 'PRODUCT_PROTOTYPE_DRAWING':
                    return '产品原型图'
                    break
                case 'PRODUCT_FLOW_DIAGRAM':
                    return '产品流程图'
                    break
                case 'UI_DESIGN':
                    return 'UI设计图'
                    break
                case 'REQUIREMENT_DESCRIPTION_DOCUMENT':
                    return '需求说明文档'
                    break
                case 'TEST_CASES_DESIGN':
                    return '测试用例'
                    break
                case 'INDUSTRIAL_PROJECT':
                    return '工业项目'
                    break
                case 'HARD_PROJECT':
                    return '硬件项目'
                    break
                case 'SCIENTIFIC_PAYOFFS':
                    return '科研成果'
                    break
                case 'DATA_ASSETS':
                    return '数据资产'
                    break
                case 'TRADEMARK_DESIGN':
                    return '商标设计'
                    break
                case 'PATENT_DOCUMENT':
                    return '专利文档'
                    break
                case 'HANDOUTS_COURSEWARE':
                    return '讲义课件'
                    break
                case 'OTHER':
                    return '其它'
                    break
            }
        },
        toggleChildAll(){
            this.childAccountName='申请账号';
            this.searchParam.applyAccount = '';
            this.$refs.fileList.scrollTop=0;
        },
        saveFileChild(){
            this.childList.forEach((item)=>{
                if(item.accountId==this.searchParam.applyAccountIds){
                    this.childAccountName=item.accountName;
                    return
                }
            });
            this.childAccountName=this.searchParam.applyAccountIds?this.childAccountName:'申请账号';
            this.childPopup=false;
            this.searchParam.page = 1;
            this.finished = false;
            this.getOpusList(filterParams(this.searchParam));
            this.$refs.fileList.scrollTop=0;
        },
        onRefresh() {
            this.searchParam.page = 1;
            this.finished = false;
            this.getOpusList(filterParams(this.searchParam));
        },
        onLoad(){
            if (this.tableData.length < this.total) {
                this.loading = true;
                this.searchParam.page++;
                this.getOpusList(filterParams(this.searchParam),true);
                this.$setlocalStorage("currentPage", this.searchParam.page);
            }else{
                this.finished =true;
            }
        },
        suffix(item) {
            if (item.sourceFileStorePath) {
                let path = item.sourceFileStorePath
                let index = path.lastIndexOf('.')
                let extension = path.substring(index + 1, path.length)
                let arry_format = ['png', 'gif', 'jpg', 'jpeg']
                if (arry_format.indexOf(extension) == '-1') {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
        lookDetail(item){
            let serialNos=[];
            let that=this;
            this.tableData.forEach((objItem,key)=>{
                serialNos.push(objItem.serialNo)
                if(key==(that.tableData.length-1)){
                    that.$setlocalStorage("listObj",{
                        searchParam:that.searchParam,
                        serialNos
                    });
                    that.$router.push({path: '/file/FileDetail',query:{serialNo:item.serialNo}})
                }
            });
        },
    },
};
</script>
<style src="../../assets/css/protectFile.less" scoped lang="less"></style>
